module.exports = __webpack_public_path__ + "img/pay_lcropay_ocal.8af05439.png";